import * as React from 'react';
import { Div, DivProps } from '@kizi/core-components';
import { ChannelWrapper, Item, Maybe } from '@kizi/comparator-core';

export const ChannelsPackages: React.FC<ChannelWrapper> = ({
  channelPackages,
}) => {
  return (
    <Div width="100%">
      {channelPackages.map(({ name, costs: { monthlyCosts } }, index) => {
        return (
          <Div
            key={index}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            variant="footnoteRegular"
            mb={2}
          >
            {name}
            <Cost monthlyCosts={monthlyCosts} />
          </Div>
        );
      })}
    </Div>
  );
};

export interface CostProps extends DivProps {
  monthlyCosts?: Maybe<Item>;
}

export const Cost = ({ monthlyCosts, ...rest }: CostProps) => {
  if (!monthlyCosts) {
    return null;
  }
  const {
    costSpecifics: { remarks },
  } = monthlyCosts;

  if (!remarks) {
    return null;
  }

  return (
    <Div
      dangerouslySetInnerHTML={{
        __html: remarks,
      }}
      textAlign="right"
      color="second.0"
      {...rest}
    ></Div>
  );
};
